import { render, staticRenderFns } from "./_base-overlay.vue?vue&type=template&id=1f88241a&scoped=true&"
import script from "./_base-overlay.vue?vue&type=script&lang=js&"
export * from "./_base-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88241a",
  null
  
)

export default component.exports